module.exports = __webpack_public_path__ + "media/images/emblems/Lostorf-blason-cd88ea88ba9f60e4d8f9dd19a5fde4fb.png";